<template>
  <div :style="`height: ${contentHeight};`" class="overflow--y pa-4">
    <div v-if="hasRole('timePolicy', 'ROLE_GET_TIMEPOLICY_TIMEPOLICYID')">
      <div class="mb-2">
        <div class="item__label">{{ $t('Common.name') }}</div>
        <div>{{ data.name || '-' }}</div>
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Common.description') }}</div>
        <div>{{ data.description || '-' }}</div>
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t(`${namespace}.frequency`) }}</div>
        <div v-if="isValidArray(data.intervals)">
          {{ $t(`${namespace}.${data.timePolicyType}`) }}
        </div>
        <div v-else>-</div>
      </div>

      <div class="mb-2">
        <div class="item__label mb-0">{{ $t(`${namespace}.intervals`) }}</div>
        <Labels
          v-if="isValidArray(data.intervals)"
          class="mb-2"
          :timePolicyType="data.timePolicyType"
          :intervals="data.intervals"
        />
        <span v-else>-</span>
      </div>

      <div>
        <div class="item__label">{{ $t('Common.costCenter') }}</div>
        <div v-if="isValidArray(data.costCenters)">
          <div v-if="data.costCenters.length > 4 && costCentersLimit">
            <span v-for="(item, index) in data.costCenters.slice(0, 4)" :key="index">
              <a
                v-if="hasRole('costCenter', 'ROLE_GET_COSTCENTER_ID')"
                class="accent--text"
                @click.prevent="change({
                  type: 'costCenter',
                  action: null
                }, {
                  id: item.id,
                  name: item.name.trim()
                })"
              >
                {{ item.name.trim() }}<span v-if="index !== (data.costCenters.slice(0, 4).length - 1)">, </span>
              </a>

              <span v-else>
                {{ item.name.trim() }}<span v-if="index !== (data.costCenters.slice(0, 4).length - 1)">, </span>
              </span>
            </span>

            <div>
              <a class="gray-8--text caption" @click="handleToggleCostCentersLimit">
                {{ $t(`${namespace}.viewMore`) }}
              </a>
            </div>
          </div>

          <div v-if="data.costCenters.length <= 4 || !costCentersLimit">
            <span v-for="(item, index) in data.costCenters" :key="index">
              <a
                v-if="hasRole('costCenter', 'ROLE_GET_COSTCENTER_ID')"
                class="accent--text"
                @click.prevent="change({
                  type: 'costCenter',
                  action: null
                }, {
                  id: item.id,
                  name: item.name.trim()
                })"
              >
                {{ item.name.trim() }}<span v-if="index !== (data.costCenters.length - 1)">, </span>
              </a>

              <span v-else>
                {{ item.name.trim() }}<span v-if="index !== (data.costCenters.length - 1)">, </span>
              </span>
            </span>

            <div v-if="data.costCenters.length > 4">
              <a class="gray-8--text caption" @click="handleToggleCostCentersLimit">
                {{ $t(`${namespace}.seeLess`) }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EmptyState
      v-else
      image="employee"
      :imageSize="120"
      class="px-4"
    >
      <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
    </EmptyState>
  </div>
</template>

<script>
import { hasRole, calcContentHeight, isArray } from 'utils/functions'
import Labels from 'components/usagePolicy/timeRangeComboBox/Labels'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Preview',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    Labels,
    EmptyState
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.timePolicy.preview',
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = `${calcContentHeight()}px`
    },

    isValidArray (val) {
      return isArray(val)
    },

    handleToggleCostCentersLimit () {
      this.costCentersLimit = !this.costCentersLimit
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    close () {
      this.$emit('close')
    },

    change (drawer, data) {
      this.$emit('change', {
        drawer: {
          type: drawer.type,
          action: drawer.action
        },
        data: {
          id: data.id,
          name: data.name
        }
      })
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>
